<script setup lang="ts">
import {computed, type PropType} from 'vue';

const props = defineProps({
    kind: {type: String as PropType<'ok' | 'warn' | 'bad' | 'info'>, required: true},
});

const style = computed<Record<string, string>>(() => ({
    background: `var(--zzc-tag-${props.kind}-bg)`,
    color     : `var(--zzc-tag-${props.kind}-fg)`,
}));
</script>

<template>
    <span class="inline-block rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap" :style="style">
        <slot/>
    </span>
</template>
